@if (!isNewEDPScoreboard) {
    <div class="score-wrapper">
        <div class="event-score event-score-snooker">
            @if (showPoints) {
                <span class="current-period-score">{{ score.participant1 }}</span>
            }
            <span class="score-counter">{{ score.frames.participant1 }}</span> <span class="score-divider"></span>
            <span class="score-counter">{{ score.frames.participant2 }}</span>
            @if (showPoints) {
                <span class="current-period-score">{{ score.participant2 }}</span>
            }
        </div>
        <div class="event-time">
            <ms-best-of [scoreboard]="event.scoreboard" />
            <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
        </div>
    </div>
    <ng-container *ngTemplateOutlet="participantDetails" />
} @else {
    <div class="snooker-scoreboard">
        <div class="event-header-live">
            <i class="live-icon"></i>
            <ms-best-of [scoreboard]="event.scoreboard" />
            @if (periodName) {
                <span class="period-name">&nbsp;• {{ periodName }}</span>
            }
        </div>
        <ng-container *ngTemplateOutlet="participantDetails" />
    </div>
    <div class="score-container">
        <ms-score-card
            [eventId]="event.id"
            [participant1Score]="score.frames.participant1.toString()"
            [participant2Score]="score.frames.participant2.toString()"
            [showSeparator]="!isNewEDPScoreboard" />
    </div>
}

<ng-template #participantDetails>
    <div class="participant-snooker">
        <ms-participant-image [participantImage]="event.participants[0].image" [sportId]="event.sport.id" />
        <ms-scoreboard-participant
            class="participant-info"
            [event]="event"
            [participant]="event.participants[0]"
            [isNewEDPScoreboard]="isNewEDPScoreboard"
            [showIndicator]="false" />
        <span class="serving" [class.serving-indicator]="score.currentlyServing === 1"></span>
    </div>
    <div class="participant-snooker">
        <ms-participant-image [participantImage]="event.participants[1].image" [sportId]="event.sport.id" />
        <ms-scoreboard-participant
            class="participant-info participant-info-snooker-right"
            [event]="event"
            [participant]="event.participants[1]"
            [isNewEDPScoreboard]="isNewEDPScoreboard"
            [showIndicator]="false" />
        <span class="serving" [class.serving-indicator]="score.currentlyServing === 2"></span>
    </div>
</ng-template>
